import { mapState } from 'vuex';
import UpsertDashboardDialog from '@/views/dashboards/components/upsertDashboardDialog.vue';
import DateTimeMixin from '@/mixins/date-time';
export default {
  name: 'ViewDashboardsList',
  components: {
    UpsertDashboardDialog
  },
  mixins: [DateTimeMixin],
  data() {
    return {
      showCreateDialog: false,
      accountFilterIsReady: false,
      selectedAccountIds: [],
      accounts: [],
      isLoadingAccounts: false,
      dashboardsResponse: {
        dashboards: [],
        total: 0
      }
    };
  },
  computed: {
    ...mapState('app', ['permissions']),
    tableHeaders() {
      return [{
        value: 'meta.name',
        text: this.$i18n_t('Dashboards.listView.table.headers.name')
      }, {
        value: 'identifier.tenantId',
        text: this.$i18n_t('Dashboards.listView.table.headers.tenantId')
      }, {
        value: 'createdAt',
        text: this.$i18n_t('Dashboards.listView.table.headers.createdAt')
      }, {
        value: 'updatedAt',
        text: this.$i18n_t('Dashboards.listView.table.headers.updatedAt')
      }];
    },
    hasEditPermissions() {
      return this.permissions['Dashboards.manage'];
    }
  },
  mounted() {
    this.fetchAccounts();
  },
  methods: {
    async fetchAccounts() {
      this.isLoadingAccounts = true;
      try {
        this.accounts = await this.$store.dispatch('app/loadAccounts', {
          n1Accounts: false
        });
      } catch (error) {
        this.$snack(this.$i18n_t('Common.errorLoadingAccounts'), 'error');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchDashboards(options) {
      if (!options) {
        return {
          items: [],
          total: -1
        };
      }
      const {
        page,
        perPage,
        selectedAccountIds,
        search,
        sortBy,
        sortDirection,
        accounts: passedAccounts
      } = options;
      const response = await this.$store.dispatch('dashboards/refresh', {
        selectedAccountIds,
        page: page,
        limit: perPage,
        search,
        sortBy,
        sortDirection
      });
      return {
        items: response.dashboards.map(dashboard => {
          var _passedAccounts$find;
          return {
            ...dashboard,
            createdAt: this.formatDateTime(dashboard.createdAt),
            updatedAt: this.formatDateTime(dashboard.updatedAt),
            identifier: {
              ...dashboard.identifier,
              tenantId: (_passedAccounts$find = passedAccounts.find(account => account.id === dashboard.identifier.tenantId)) === null || _passedAccounts$find === void 0 ? void 0 : _passedAccounts$find.name
            }
          };
        }),
        total: response.total
      };
    },
    onSave(dashboard) {
      this.$router.push(`/dashboards/${dashboard.id}`);
    },
    async deleteDashboard(dashboard) {
      const {
        success,
        error
      } = await this.$store.dispatch('dashboards/deleteById', dashboard.id);
      if (!success) {
        throw error;
      }
    },
    onAccountFilterChange(accounts) {
      this.selectedAccountIds = accounts.map(account => account.id);
    }
  }
};